import { render, staticRenderFns } from "./copyrightDisplayDetail.vue?vue&type=template&id=776da77d&scoped=true&"
import script from "./copyrightDisplayDetail.vue?vue&type=script&lang=js&"
export * from "./copyrightDisplayDetail.vue?vue&type=script&lang=js&"
import style0 from "./copyrightDisplayDetail.vue?vue&type=style&index=0&id=776da77d&prod&lang=less&scoped=true&"
import style1 from "./copyrightDisplayDetail.vue?vue&type=style&index=1&id=776da77d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776da77d",
  null
  
)

export default component.exports